import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef} from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Skeleton from 'react-loading-skeleton'
import ConfirmPopup from './../modal/modal';
import ManagementTable from "./../tables/managementTable";
import { boolToYesNo, getUnits, stripHTML, setConfig, getConfig, getYesNo} from "../../utils"
import cloneDeep from 'lodash/cloneDeep';


const TemplatesAdmin = () => {

    let navigate = useNavigate();
    const {usersAdminStore,loginStore,templatesStore}= useStores();
    const { getAllUsers, users, templates, getAll, remove, duplicate, getAllWithOptions/*, setConfig, config*/ } = templatesStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);

    /*useEffect(() => {
        setIsLoading(true);
        async function fetchMyAPI() {
            getAll().then(() => {
                setIsLoading(false);
            });
        }

        fetchMyAPI();
    }, [getAll]);*/
    /**useEffect(() => {
        alert(templates?.results?.length?.toString())
    }, [templates?.results])*/

    const onPageChange = (props) => {
        var newProps = cloneDeep(props);

        newProps.filterBy?.filters?.forEach(main => {
            main?.filters?.forEach(f => {
                /*if (["workUnit", "billingUnit", "salaryUnit"].indexOf(f.field) > -1) {
                    f.value = getUnitOptions()?.find(x => x.text == f.value)?.value;
                }*/

            });
        });
        setIsLoading(true);
        getAllWithOptions(newProps/*props.page + 1, props.filter, props.sort*/).then(() => {
            setIsLoading(false);
        });
    }

    return (
        <ManagementTable name={t('templates')} ref={tableRef} isLoading={isLoading}
            config={{
                size: getConfig("templates", "size"),
                dataState: getConfig("templates", "dataState")
            }}
            onColumnSizeChange={(c) => setConfig("templates", "size", c)}
            onDataStateChange={(c) => { setConfig("templates", "dataState", c) }}

            //filters={["name"]}
            /*onDelete={(id) => {
                remove(id).then(() => { tableRef?.current?.resetPage() })
            }}*/
            /*onEdit={(id) => {
                alert(id)
            }}*/
            items={templates?.results} onPageChange={onPageChange} pageCount={templates?.pageCount} total={templates?.count} pageSize={templates?.pageSize} columns={
                [
                    { name: "title", prop: "name"},
                ]}
            extraButtons={
                [
                    { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) } },
                    { text: t('copy'), icon: solid("copy"), onClick: (id) => { duplicate(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmCopy"), modalTitle: t("copy") },
                    { text: t('delete'), icon: solid("trash"), onClick: (id) => { remove(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true }
                ]
            }
             />

    );

   
};

export default observer(TemplatesAdmin);
